export default __webpack_public_path__ + "static/media/close.c38d32f5.svg";